module.exports = __webpack_public_path__ + "static/media/buxton-10.3b466bcc.jpg";